<template>
  <nav class="services">
    <router-link v-for="(service, index) in services" :key="index" :to="service.route">
      <img :src="require(`@/assets/img/about/${service.img}`)" :alt="service.title">
      <v-heading level="h5">{{service.title}}</v-heading>
      <i class="icon-arrow"></i>
    </router-link>
  </nav>
</template>

<script>
import Heading from '@/components/uikit/text/Heading.vue';

const services = [
  { title: 'Nossos Exames', img: 'service-1.jpg', route: '/exames' },
  { title: 'Convênios Parceiros', img: 'service-2.jpg', route: '/convenios' },
  { title: 'Aperfeiçoamento Médico', img: 'service-3.jpg', route: '/aperfeicoamento-medico' },
  { title: 'Trabalhe conosco', img: 'service-4.jpg', route: '/trabalhe-conosco' },
];

export default {
  name: 'Services',
  components: {
    'v-heading': Heading,
  },
  data() {
    return {
      services,
    };
  },
};
</script>

<style lang="scss" scoped>
$component: '.services';
#{$component} {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: $gutter-l;
  @media screen and (max-width: #{$brakepoint-medium}) {
    grid-template-columns: repeat(2, 1fr);
  }
  a {
    position: relative;
    overflow: hidden;
    display: grid;
    grid-template-columns: 3fr 1fr;
    grid-template-rows: 3fr 1fr;
    align-items: center;
    justify-items: center;
    height: 280px;
    border-radius: $border-radius;
    text-decoration: none;
    @media screen and (max-width: #{$brakepoint-large}) {
      height: 216px;
    }
    &:before {
      z-index: 2;
      content: '';
      width: 100%;
      height: 100%;
      grid-column: 1 / 3;
      grid-row: 1 / 3;
      background-color: rgba($color-sys-k, 0.6);
      transition: background-color $transition-duration * 2 $transition-timing-function;
    }
    img {
      z-index: 1;
      grid-column: 1 / 3;
      grid-row: 1 / 3;
    }
    .heading {
      z-index: 4;
      grid-column: 1 / 2;
      grid-row: 2 / 3;
      align-self: center;
      padding: $gutter-l;
      margin: auto;
      color: $color-sys-k;
    }
    i {
      z-index: 4;
      grid-column: 2 / 3;
      grid-row: 2 / 3;
      align-self: center;
      color: $color-sys-k;
      transition: transform $transition-duration * 2 $transition-timing-function;
    }
    &:after {
      position: absolute;
      z-index: 3;
      content: '';
      width: 320px;
      height: 320px;
      bottom: 0;
      left: 50%;
      border-radius: 50%;
      background-color: rgba($color-a, .8);
      transform: translate(-50%, calc(100% - 110px));
      transition: transform $transition-duration * 2 $transition-timing-function,
        background-color $transition-duration * 2 $transition-timing-function;
    }
    &:hover {
      &:before {
        background-color: transparent;
      }
      &:after {
        transform: translate(-50%, calc(100% - 126px));
        background-color: $color-b;
      }
      i {
        transform: translateX($gutter/2);
      }
    }
  }
}
</style>
